<template>
  <section>
    <h3 class="trip-title">
      Viagem
    </h3>
    <article
      v-if="verifyStatus"
      class="d-flex align-start alert-box"
    >
      <v-icon color="#FFB400">
        {{ icons.mdiAlertCircleOutline }}
      </v-icon>
      <div
        class="d-flex flex-column alert-content"
      >
        <span class="alert-title">{{ solicData.is_parent ? 'Aguardando iniciar' : 'A viagem não pode ser iniciada aqui!' }}</span>
        <span class="alert-subtitle">{{ solicData.is_parent ? 'Inicie quando estiver pronto para começar o trajeto' : 'O status da viagem pode apenas ser visualizado nesta solicitação, pois ela é uma solicitação filha. O início da viagem deve ser realizado na solicitação pai, responsável por gerenciar todos os vínculos.' }}</span>
        <div
          v-if="solicData.is_child"
          class="go-to-parent-link"
          style="display: inline-flex; gap: 1px; align-items: center; cursor: pointer;"
          @click="goToParentSolicitation"
        >
          <span style="color: #0085FF; font-weight: 500;">
            Ir para a solicitação pai desta solicitação
          </span>
          <v-icon
            color="#0085FF"
          >
            {{ icons.mdiArrowTopRight }}
          </v-icon>
        </div>
      </div>
    </article>
    <div class="mt-8">
      <span class="details-title">Detalhes</span>
      <div class="d-flex align-start mt-8 details-row">
        <div class="d-flex items-center detail-item">
          <v-icon
            size="22"
            color="#E7E3FC"
          >
            {{ icons.mdiCarHatchback }}
          </v-icon>
          <span class="vehicle-info">Veículo: <strong class="vehicle-plate">{{ (solicData.vehicle && solicData.vehicle.car_plate) || 'N/A' }}</strong> - {{ (solicData.vehicle && solicData.vehicle.manufacturer && solicData.vehicle.manufacturer.name) || 'N/A' }} {{ (solicData.vehicle && solicData.vehicle.model) || '' }}</span>
        </div>
        <div class="d-flex items-center destination-info">
          <span class="destination-label">
            Destino:
          </span>
          <div class="elipsis-rounded-blue mt-2 destination-marker"></div>
          <div class="d-flex flex-column destination-details">
            <span class="destination-name">{{ (solicData.address && solicData.address.local_name) || 'Destino não informado' }}</span>
            <span class="destination-address">{{ solicData.address ? formatAddress(solicData.address) : 'Endereço não disponível' }}</span>
          </div>
        </div>
      </div>
      <div class="timer-container">
        <div class="d-flex items-center timer-label">
          <v-icon
            color="#56CA00"
            size="20"
          >
            {{ icons.mdiClockTimeEightOutline }}
          </v-icon>
          <span class="timer-text">TEMPO EM TRÂNSITO</span>
        </div>
        <span class="timer-value">
          {{ solicData.trip_duration ? solicData.trip_duration : 'Calculando' }}
        </span>
      </div>
      <div
        v-if="solicData.status !== 'Finalizada' && solicData.status !== 'Cancelada'"
        class="d-flex align-center"
        style="gap: 20px;"
      >
        <v-btn
          v-if="!solicData.is_child && !solicData.status === 'Em trânsito'"
          color="info"
          :disabled="isStartingTrip"
          @click="startTrip"
        >
          <div
            v-if="!isStartingTrip"
            class="d-flex align-center btn-content"
          >
            <v-icon>{{ icons.mdiPlay }}</v-icon>
            <span>INICIAR VIAGEM</span>
          </div>
          <v-progress-circular
            v-else
            indeterminate
            color="white"
            size="20"
          ></v-progress-circular>
        </v-btn>
        <v-btn
          v-show="solicData.status === 'Em trânsito'"
          color="error"
          :disabled="isEndingTrip"
          @click="endTrip"
        >
          <div
            v-if="!isEndingTrip"
            class="d-flex align-center btn-content"
          >
            <v-icon>{{ icons.mdiStop }}</v-icon>
            <span>FINALIZAR VIAGEM</span>
          </div>
          <v-progress-circular
            v-else
            indeterminate
            color="white"
            size="20"
          ></v-progress-circular>
        </v-btn>
      </div>
      <div class="mt-8 fuel-section">
        <div class="d-flex items-center fuel-header">
          <v-icon color="#16B1FF">
            {{ icons.mdiGasStationOutline }}
          </v-icon>
          <span>Abastecimento</span>
        </div>
        <div class="alert-box-blue">
          <div
            class="d-flex flex-column"
            style="gap: 10px;"
          >
            <span style="font-weight: 700; font-size: 14px;">{{ supplyHistory.total_supplies }} abastecimentos registrados</span>
            <span style="font-weight: 500; font-size: 13px;">Total: {{ formatToReal(supplyHistory.total_amount_paid) }} • {{ supplyHistory.total_liters_supplied }} litros</span>
          </div>
          <div
            class="d-flex items-center"
            style="gap:20px;"
          >
            <v-btn
              v-if="solicData.status !== 'Finalizada'"
              color="info"
              @click="lauchSupplyModal"
            >
              <span>LANÇAR ABASTECIMENTO</span>
            </v-btn>
            <v-btn
              color="white"
              outlined
              @click="opanModalhistory"
            >
              <span>VER HISTÓRICO</span>
            </v-btn>
          </div>
        </div>
      </div>
    </div>

    <v-dialog
      v-model="launchSupplyModal"
      max-width="700px"
    >
      <RegisterFuelSuplyModal
        v-if="launchSupplyModal"
        :vehicle-data="vehiclesList"
        :drivers-data="driversList"
        :list-fuel-type="listFuelType"
        :trip-id="solicData.id"
        @close="launchSupplyModal = false"
        @update="$emit('updateTable')"
      />
    </v-dialog>

    <v-dialog
      v-model="openSupplyHistory"
      max-width="600px"
    >
      <SupplyHistory
        v-if="openSupplyHistory"
        :solic-data="solicData"
        :supply-history-list="supplyHistory"
        @close="openSupplyHistory = false"
      />
    </v-dialog>
  </section>
</template>

<script>
import axiosIns from '@/plugins/axios'
import {
  mdiAlertCircleOutline,
  mdiArrowTopRight,
  mdiCarHatchback,
  mdiClockTimeEightOutline,
  mdiGasStationOutline,
  mdiPlay, mdiStop,
} from '@mdi/js'
import RegisterFuelSuplyModal from '../../../Registrations/FuelSupply/modais/RegisterFuelSuplyModal.vue'
import { formatAddress } from '../../helpers/formatHelpers'
import SupplyHistory from '../SupplyHistory.vue'

export default {
  name: 'TripTab',
  components: {
    RegisterFuelSuplyModal,
    SupplyHistory,
  },
  props: {
    solicData: {
      type: Object,
      default: () => ({}),
    },
    usersList: {
      type: Array,
      default: () => [],
    },
    vehiclesList: {
      type: Array,
      default: () => [],
    },
    driversList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      formatAddress,
      icons: {
        mdiAlertCircleOutline,
        mdiCarHatchback,
        mdiPlay,
        mdiStop,
        mdiClockTimeEightOutline,
        mdiGasStationOutline,
        mdiArrowTopRight,
      },
      isStartingTrip: false,
      isEndingTrip: false,
      tripTime: '00:00:00',
      tripTimer: null,
      launchSupplyModal: false,
      openSupplyHistory: false,
      supplyHistory: [],
      listFuelType: [],
    }
  },

  computed: {
    verifyStatus() {
      if ((this.solicData.is_parent || this.solicData.is_child) && this.solicData.status !== 'Finalizada' && this.solicData.status !== 'Cancelada') {
        return true
      }

      if (this.solicData.is_manual && this.solicData.is_child) {
        return true
      }

      return false
    },
  },

  created() {
    this.getFuelTypeList()
    this.getHistorySupply()
  },

  methods: {
    goToParentSolicitation() {
      if (!this.solicData.parent_id) {
        this.$swal({
          icon: 'warning',
          title: 'Aviso',
          text: 'Não foi possível identificar a solicitação pai.',
        })

        return
      }

      this.$emit('open-parent-solicitation', this.solicData.parent_id)
    },

    async getHistorySupply() {
      try {
        const { data } = await axiosIns.get(`/api/v1/transport/vehicles_supplies/get_by_trip_id/${this.solicData.id}`)
        this.supplyHistory = data
      } catch (error) {
        console.error('Erro ao buscar o histórico de abastecimento', error)
      }
    },

    async getFuelTypeList() {
      try {
        const { data } = await axiosIns.get('/api/v1/transport/tools/vehicles/fuel_type/index')
        this.listFuelType = data.data
      } catch (error) {
        console.error('Erro ao buscar os tipos de combustivel', error)
      }
    },

    async startTrip() {
      this.isStartingTrip = true
      try {
        const response = await axiosIns.patch(`/api/v1/solicitations/transport_solicitation_trip/start_or_end/${this.solicData.id}?action=start`)
        console.log('Trip started!', response)
      } catch (error) {
        console.error('Error starting trip:', error)
      } finally {
        this.isStartingTrip = false

        this.$emit('updateTable')
        this.$emit('close')
      }

      // Here you can add the logic to actually start the trip, e.g., API call
    },
    async endTrip() {
      this.isEndingTrip = true
      try {
        const response = await axiosIns.patch(`/api/v1/solicitations/transport_solicitation_trip/start_or_end/${this.solicData.id}?action=end`)
        this.$swal({
          icon: 'success',
          title: 'Sucesso!',
          text: `${response.data.message || 'A viagem foi finalizada com sucesso.'}`,
          showConfirmButton: false,
          timer: 3000,
        })
      } catch (error) {
        console.error('Error ending trip:', error)
      } finally {
        this.isEndingTrip = false

        this.$emit('updateTable')
        this.$emit('close')
      }

      // Here you can add the logic to actually end the trip, e.g., API call
    },

    formatToReal(valueInt) {
      if (!valueInt && valueInt !== 0) return 'R$ 0,00'

      const valueFloat = valueInt / 100

      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      }).format(valueFloat)
    },

    lauchSupplyModal() {
      this.launchSupplyModal = true

      // Logic to launch supply modal
    },

    opanModalhistory() {
      this.openSupplyHistory = true
    },
  },
}
</script>

<style scoped>
  .trip-title {
    font-weight: 600;
    font-size: 18px;
    color: #E7E3FC;
  }

  .alert-box {
    gap: 10px;
    margin-top: 32px;
    padding: 20px;
    border: 1px solid #FFB4001A;
    border-radius: 5px;
  }
  .alert-box-blue {
    background: #16B1FF0D;
    gap: 10px;
    margin-top: 32px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 32px;
    border: 1px solid #16B1FF33;
    border-radius: 5px;
  }

  .alert-content {
    gap: 10px;
  }

  .alert-title {
    font-weight: 600;
    font-size: 14px;
    color: #E7E3FC;
  }

  .alert-subtitle {
    font-weight: 500;
    font-size: 14px;
    color: #E7E3FC;
  }

  .details-title {
    font-weight: 600;
    font-size: 14px;
    color: #E7E3FC;
  }

  .details-row {
    gap: 91px;
  }

  .detail-item {
    gap: 10px;
  }

  .vehicle-info {
    color: #E7E3FC;
    font-size: 14px;
    font-weight: 500;
  }

  .vehicle-plate {
    color: #E7E3FC;
    background: #E7E3FC1A;
    font-size: 14px;
    font-weight: 600;
    border-radius: 30px;
    padding: 5px 3.5px;
  }

  .destination-info {
    color: #E7E3FC;
  }

  .destination-label {
    font-size: 14px;
    font-weight: 500;
  }

  .destination-marker {
    margin: 0px 10px;
  }

  .destination-details {
    gap: 6px;
  }

  .destination-name {
    font-size: 14px;
    font-weight: 600;
  }

  .destination-address {
    font-size: 12px;
    font-weight: 500;
  }

  .elipsis-rounded-blue {
    display: inline-block;
    width: 9px;
    height: 9px;
    background: #16B1FF;
    border-radius: 100%;
    box-shadow: 0 0 0 3px #16B1FF33;
  }

  .timer-container {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-direction: column;
    justify-content: center;
    background: #00000080;
    border-radius: 10px;
    padding: 16px 0px;
    margin: 32px 0;
  }

  .timer-label {
    gap: 10px;
  }

  .timer-text {
    font-weight: 500;
    font-size: 12px;
    color: #fff;
  }

  .timer-value {
    font-weight: 500;
    font-size: 24px;
    color: #fff;
  }

  .btn-content {
    gap: 10px;
  }

  .fuel-section {
    color: #E7E3FC;
  }

  .fuel-header {
    gap: 10px;
  }

  .go-to-parent-link {
    transition: all 0.2s ease;
  }

  .go-to-parent-link:hover {
    transform: translateX(3px);
    opacity: 0.8;
  }
</style>
